import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Brands from './Brands';
import ProductTags from './ProductTags';
import ProductTypes from './ProductTypes';
import Supplier from './Suppliers/index';
import Suppliers from './Suppliers';
import PriceBooks from './PriceBooks';
import MainProduct from './Main';
import Promotions from './Promotions';

const productsParent = ({ match }) => (
    <Switch>
        <Route path={`${match.url}/Main`} component={MainProduct} />
        <Route path={`${match.url}/Brands`} render={props => <Brands {...props} />} />
        <Route path={`${match.url}/ProductTypes`} component={ProductTypes} />
        <Route path={`${match.url}/Supplier`} component={Suppliers} />
        <Route path={`${match.url}/PriceBook`} component={PriceBooks} />
        <Route path={`${match.url}/ProductTags`} render={props => <ProductTags{...props} />} />
        <Route path={`${match.url}/ProductTypes`} render={props => <ProductTypes{...props} />} />
        <Route path={`${match.url}/Supplier`} render={props => <Supplier{...props} />} />
        <Route path={`${match.url}/Promotions`} component={Promotions} />
    </Switch>
);

export default productsParent;